import React from "react";

export default () => (
  <svg width="100%" height="100%">
    <image x="0" y="0" width="100%" height="100%" href="/static/svg/logo.svg" />
  </svg>
);
